module.exports = __webpack_public_path__ + "static/img/camera-img.5a58861.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/camera-img.jpg
// module id = Z8CQ
// module chunks = 1